"use strict";

import Swal from 'sweetalert2';
import intlTelInput from 'intl-tel-input';



function isScrolledIntoView(element) {
    return new Promise(resolve => {
        var options = {
            root: null,
            rootMargin: '0px',
            threshold: 1.0
        };

        let observer = new IntersectionObserver(entries => {
            const entry = entries[0];
            if (entry.intersectionRatio > 0) {
                resolve(true);
                observer.disconnect();
            }
        }, options);

        observer.observe(element);
    });
}

var formPOST = function () {
    let forms = document.querySelectorAll('form[method="post"]:not(.ajax)');
    if (forms.length > 0) {
        forms.forEach(function (el) {
            el.addEventListener('submit', function (e) {
                e.preventDefault();
                let form = this;
                let security = form.getAttribute('data-security-recaptcha')
                if (security !== null) {
                    var script = document.createElement('script')
                    script.src = '//www.google.com/recaptcha/api.js?render=' + security
                    document.head.appendChild(script)
                }

                form.querySelector('[type="submit"]').setAttribute('disabled', 'disabled');
                Swal.fire({
                    title: i18n.General.Ajax.form_sending.title,
                    icon: 'info',
                    showConfirmButton: false,
                    showCancelButton: false,
                    allowEnterKey: false,
                    footer: i18n.General.Ajax.form_sending.message,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                })
                setTimeout(() => {


                    if (security !== null) {
                        grecaptcha.ready(function () {
                            grecaptcha.execute(security, {action: 'submit'}).then(function (token) {
                                let input = document.createElement('input');
                                input.type = 'hidden';
                                input.name = 'recaptcha';
                                input.value = token;
                                form.appendChild(input);
                            });
                        });
                        let recaptchaInterval = setInterval(() => {
                            let recaptcha = form.querySelector('[name="recaptcha"]');
                            if (recaptcha !== null) {
                                clearInterval(recaptchaInterval);
                                form.submit();
                            }
                        }, 50);
                    } else {
                        form.submit();
                    }


                }, 300);
            })
        });
    }
}


var observer = function () {

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const img = entry.target;

            // img
            if (img.dataset.src) {
                img.src = img.dataset.src;
            }

            // picture source'lar
            const picture = img.closest('picture');
            if (picture) {
                picture.querySelectorAll('source[data-srcset]').forEach(source => {
                    source.srcset = source.dataset.srcset;
                });
            }

            img.classList.add('loaded');
            img.classList.remove('lazy');
            observer.unobserve(img);
        });
    }, {
        rootMargin: "200px 0px"
    });


    $(function () {
        let srcItems = document.querySelectorAll('[data-src]');
        srcItems.forEach(box => {
            observer.observe(box);
        });
    });

    const lazyBackgroundImages = document.querySelectorAll('.lazy-bg');


    const imageObserver = new IntersectionObserver((entries, imageObserver) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                showImageBackground(entry.target);
                imageObserver.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0,
        rootMargin: "0px 0px 50px 0px"
    });

    lazyBackgroundImages.forEach(image => {
        imageObserver.observe(image);
    });

    function showImageBackground(node) {
        node.classList.remove('lazy-bg');
    }
}

var mobilMenu = function () {
    if ($('header .mobile').length) {
        $('header .mobile').initMM({
            enable_breakpoint: true,
            mobile_button: true,
            breakpoint: 1200,
        });
    }
}
var intTelInput = function () {
    let input = document.querySelectorAll(".phone-input");
    if (input.length > 0) {
        input.forEach(function (el) {
            let iti = intlTelInput(el, {
                utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@21.0.4/build/js/utils.js",
                initialCountry: "tr",
                showSelectedDialCode: true,
                strictMode: true,
                geoIpLookup: function (success, failure) {
                    fetch("https://ip-api.com/json")
                        .then(function (res) {
                            return res.json();
                        })
                        .then(function (data) {
                            success(data.countryCode);
                        })
                        .catch(function () {
                            failure();
                        });
                }
            });

            el.form?.addEventListener("submit", function (e) {
                el.value = iti.getNumber();
            });
        });
    }
}

jQuery(document).ready(function () {
    formPOST();
    observer();
    intTelInput();
    mobilMenu();
});


document.addEventListener('DOMContentLoaded', () => {

    function wowAnimations(element, $delay) {
        $(element).children().each(function (element, index) {
            var $ths = $(index);

            // $ths.addClass("wow");
            // $ths.addClass($animation);
            $ths.attr("data-aos-duration", ".5s");
            $ths.attr("data-aos-delay", $delay + "s");
            $ths.attr("data-aos", "fade-up");
            $ths.attr("data-aos-anchor-placement", "top-bottom");
            $delay = $delay + 0.1;
            $delay = $delay.toFixed(2)

            if ($ths.data('aos-subs')) {
                wowAnimations($ths, $delay);
            }

            $(element).find('*').each(index, element)
            {
                if ($ths.data('aos-subs')) {
                    wowAnimations($(element), $delay)
                }
            }
        })

        return $delay;
    }


    if (typeof AOS !== 'undefined' && AOS) {
        $('[data-aos-animate]').each(function () {
            var $delay = 0;


            let wrapper = $(this);

            wrapper.children().each(function (element, index) {
                var $ths = $(index);


                if (!$ths.data('aos-subs')) {
                    // $ths.addClass("wow");
                    // $ths.addClass($animation);
                    $ths.attr("data-aos-duration", ".5s");
                    $ths.attr("data-aos-delay", $delay + "s")
                    $ths.attr("data-aos", "fade-up");
                    $ths.attr("data-aos-anchor-placement", "top-bottom");
                    $delay = $delay + 0.1;
                }
            })

            wrapper.find('*').each(function (index, element) {
                if ($(element).data('aos-subs')) {
                    $delay = wowAnimations($(element), $delay)
                }
            })
        })
        AOS.init();
    }

})


export {
    isScrolledIntoView
};


